var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSmFf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2C61EAAB-AB23-43B7-AE8F-98E31A986218") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data-Map-icons",
    transform: "translate(-338.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(338.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,0 C10.5213084,0 0,10.5213084 0,23.5 C0,36.4786916 10.5213084,47 23.5,47 C36.4786916,47 47,36.4786916 47,23.5 C47,10.5213084 36.4786916,0 23.5,0 Z",
    id: "Path-Copy-11",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7132725,17.0003236 L21.5611409,17.008804 C19.4888949,17.1558447 17.7054219,18.5742752 17.0030659,20.6011395 L16.9652206,20.715107 L16.91971,20.726351 C15.1547773,21.1872902 13.915632,22.897526 14.0044897,24.8385026 C14.0038774,27.1091734 15.6103069,29 17.6207091,29 L26.6151426,29 C29.0631428,29 31,26.7113692 31,23.905845 C31,21.096487 29.0602935,18.7878506 26.6151426,18.7878506 L26.4233862,18.7965984 C26.1688796,18.8143894 25.9191998,18.8566314 25.6761783,18.9226297 L25.5420401,18.9623616 L25.4900722,18.8938517 C24.5706414,17.7266347 23.2046021,17.0282215 21.7437469,17 L21.7132725,17.0003236 Z M21.6112521,18.1253409 L21.7365798,18.1175573 L21.7240792,18.117276 C23.0042344,18.1420067 24.1917149,18.8217945 24.9029977,19.9370869 C25.0445791,20.1590868 25.3163034,20.2451334 25.5515673,20.1424686 C25.8924738,19.9937034 26.2569852,19.9132221 26.6262069,19.9051964 C28.4387227,19.9053166 29.9332977,21.6841582 29.9332977,23.905845 C29.9332977,26.1221664 28.4435072,27.882534 26.6151426,27.882534 L17.6207091,27.882534 C16.2645941,27.882534 15.1301345,26.5881614 15.0728487,24.9423804 L15.0705796,24.8117374 C15.0011011,23.280682 16.034976,21.9679934 17.4578704,21.7531032 C17.6690613,21.7212084 17.8417822,21.560523 17.8969704,21.3446007 C18.3562,19.5478739 19.8508613,18.2601169 21.6112521,18.1253409 Z",
    id: "internet-cloud-copy",
    fill: "#292929"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSmFf);
export default __webpack_public_path__ + "static/media/cloud-sm-ff.dc7036ffc8aaf12510fe7fdf60583c85.svg";
export { ForwardRef as ReactComponent };